import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import StaticSearch from 'Features/StaticCategory/components/StaticSearch';
import { fetchGamesNotOnSale } from 'Redux/ducks/algolia-calls';
import globalMessages from 'Helpers/Messages/category-messages';

const messages = defineMessages({
  title: {
    id: 'full-price-games.title',
    defaultMessage: 'Full Price Games',
  },
  fullTitle: {
    id: 'full-price-games.seotitle',
    defaultMessage: 'Full Price Games | Top pick of fantastic AAA and Indie PC releases',
  },
  desc: {
    id: 'full-price-games.seodesc',
    defaultMessage: 'Experience exciting adventures and explore new worlds with our pick of the biggest and best PC titles available.',
  },
});

export default function NotOnSale() {
  const { formatMessage } = useIntl();
  const crumbs = [
    {
      label: formatMessage(globalMessages.pcgames),
      link: '/all-games',
    },
    {
      label: formatMessage(messages.title),
      link: '/full-price-games',
    },
  ];

  return (<StaticSearch
    updateHits={fetchGamesNotOnSale}
    url="full-price-games"
    topBanner="full_price_games"
    seoBlurb={messages.desc}
    crumbs={crumbs}
    pageLimit={10}
    {...messages}
  />);
}
